/**
 *
 * Asynchronously loads the component for FormattedInput
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));

export const FormattedInputWithMentions = loadable(() => import('./index'), {
  resolveComponent: (components) => components.FormattedInputWithMentions,
});
